<template>
    <el-menu class="side-bar" mode="vertical" ref="sideMenu"
             :default-active="activeIndex" router :unique-opened="true" active-text-color="#409EFF"
             text-color="#666" background-color="#ffffff">
        <template v-for="(item, index) in allMenuList">
            <el-menu-item :index="''+item.id" v-if="item.menuLevelTwoList.length === 0"
                          @click="showMenu(item)">
                <span style="margin-left: 5px; color: #409EFF" v-if="activeIndex.startsWith(item.id)">{{item.title}}</span>
                <span style="margin-left: 5px;" v-else>{{item.title}}</span>
            </el-menu-item>
            <el-submenu :index="''+item.id" v-else @click.native="showMenu(item)">
                <template slot="title">
                    <span style="margin-left: 5px; color: #409EFF" v-if="activeIndex.startsWith(item.id)">{{item.title}}</span>
                    <span style="margin-left: 5px;" v-else>{{item.title}}</span>
                </template>
                <template v-for="(child, index) in item.menuLevelTwoList">
                    <el-menu-item :index="item.id + '_' + child.id"
                                  v-if="child.articleList.length === 0"
                                  @click.native.stop="showSubMenu(item, child)">
                        <span style="margin-left: 5px; color: #409EFF" v-if="activeIndex.startsWith(item.id + '_' + child.id)">{{child.title}}</span>
                        <span style="margin-left: 5px; " v-else>{{child.title}}</span>
                    </el-menu-item>
                    <el-submenu :index="item.id + '_' + child.id" v-else
                                @click.native.stop="showSubMenu(item, child)">
                        <template slot="title">
                            <span style="margin-left: 5px; color: #409EFF" v-if="activeIndex.startsWith(item.id + '_' + child.id)">{{child.title}}</span>
                            <span style="margin-left: 5px; " v-else>{{child.title}}</span>
                        </template>
                        <template v-for="(grandson, index) in child.articleList">
                            <el-menu-item
                                    :index="item.id + '_' + child.id + '_' + grandson.id"
                                    @click.native.stop="showArticle(item, child, grandson)">
                                <span style="margin-left: 5px">{{grandson.title}}</span>
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
            </el-submenu>
        </template>
    </el-menu>
</template>

<script>
    export default {
        name: "SideMenu",
        props: {
            activeIndex: {
                type: String,
                default: ""
            },
            allMenuList: {
                type: Array,
                default: []
            }
        },
        components: {},
        data() {
            return {

            }
        },
        computed: {

        },
        watch: {},
        methods: {
            openMenu(index) {
                // console.log("openMenu " + index)
                let newIndex = index
                if (index.split("_").length === 3) {
                    newIndex = index.split("_")[0] + "_" + index.split("_")[1]
                }
                if (this.$refs.sideMenu) {
                    this.$refs.sideMenu.open(newIndex)
                }
            },

            showMenu(menu) {
                let sideInfo = {
                    menu: menu
                }
                this.$store.commit(this.$mutation.SIDE_INFO, sideInfo)
                // this.$emit('refresh')
            },
            showSubMenu(menu, subMenu) {
                // this.getSubMenuContent(subMenu.id)
                let sideInfo = {}
                sideInfo.menu = menu
                sideInfo.submenu = subMenu
                // this.activeIndex = menu.id + "_" + subMenu.id
                this.$store.commit(this.$mutation.SIDE_INFO, sideInfo)
                // console.log("showSubMenu activeIndex is " + this.activeIndex)
                // window.sessionStorage.setItem('activeIndex', this.activeIndex)
                // this.$router.push("/" + menu.id + "_" + subMenu.id)
                this.$emit('refresh')
            },
            showArticle(menu, subMenu, article) {
                let sideInfo = {}
                sideInfo.menu = menu
                sideInfo.submenu = subMenu
                sideInfo.article = article
                this.$store.commit(this.$mutation.SIDE_INFO, sideInfo)
                // this.activeIndex = menu.id + "_" + subMenu.id + "_" + article.id
                // window.sessionStorage.setItem('activeIndex', this.activeIndex)
                // this.$router.push("/" + menu.id + "_" + subMenu.id + "_" + article.id)
                this.$emit('refresh')
                // this.getArticleContent(article.id)
            },
        },
        mounted() {
            // console.log("SideMenu activeIndex " + this.activeIndex)
            this.openMenu(this.activeIndex)
        }
    };
</script>

<style lang="less" scoped>
    .side-bar {
        width: 230px;
        height: 100%;
        overflow-y: scroll;
        background-color: white;
    }
</style>
